import { createReducer } from "@reduxjs/toolkit";

const initialState ={
        loading:false,
        counsellorCallHistory: [],
        counsellorChatHistory: [],
        counsellorPaymentHistory:[],
        totalEarn:0,
        toBePaid:0,
        currentPage: 1,
        totalPages: 1,
        totalRecords:0,
        error: null
}

export const CounsellorApiReducer = createReducer(initialState,{

    getCounsCallHistorySuccess: (state, action) => {
        state.loading = false;
        state.counsellorCallHistory= action.payload.call_history;
        state.currentPage= action.payload.currentPage;
        state.totalPages= action.payload.totalPages;
        state.totalRecords= action.payload.totalRecords;
    },

    getCounsCallHistoryFail: (state, action) => {
        state.loading = false;
        state.counsellorCallHistory= [];
        state.currentPage= 1; 
        state.totalPages=1; 
        state.totalRecords=0;
        state.error = action.payload;
    },  


    getCounsChatHistorySuccess: (state, action) => {
        state.loading = false;
        state.counsellorChatHistory= action.payload.chat_history;
        state.currentPage= action.payload.currentPage;
        state.totalPages= action.payload.totalPages;
        state.totalRecords= action.payload.totalRecords;
    },

       getCounsChatHistoryFail: (state, action) => {
        state.loading = false;
        state.counsellorChatHistory= [];
        state.currentPage= 1; 
        state.totalPages=1; 
        state.totalRecords=0;
        state.error = action.payload;
    },  


    getCounsPaymentHistorySuccess: (state, action) => {
        state.loading = false;
        state.counsellorPaymentHistory= action.payload.counsellor_transaction;
        state.currentPage= action.payload.currentPage;
        state.totalPages= action.payload.totalPages;
        state.totalRecords= action.payload.totalRecords;
        state.toBePaid= action.payload.to_be_paid; 
        state.totalEarn= action.payload.total_earn; 
    },
    getCounsPaymentHistoryFail: (state, action) => {
        state.loading = false;
        state.counsellorPaymentHistory= [];
        state.currentPage= 1; 
        state.totalPages=1; 
        state.totalRecords=0;
        state.toBePaid=0; 
        state.totalEarn=0; 
        state.error = action.payload;
    },  


        ///////common /////////
        loadingCounsRequest: state => {
            state.loading = true;
        },

        clearError: state => {
            state.error = null;
        },
        clearMessage: state => {
            state.message = null;
        },

        SessionExpired: (state, action) => { //Session expired.
            state.loading = false;
            state.error = action.payload;
            state.isAuthenticated = false;
            state.user ='';
            window.localStorage.clear();
            window.sessionStorage.clear();
        },
        

});